export var BIG_RECEIPT_SUCCESS = 'Your receipt was successfully downloaded.';
export var BIG_RECEIPT_FAILURE = 'An error occured while downloading your receipt. Please try again.';
export var REVIEW_PICK_UP_OPTIONS = 'Review your options below.';
